import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiHome, FiArrowLeft, FiAlertCircle } from "react-icons/fi";
import logo from "../assets/melona logo.png";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "404 - Page Not Found | Melona Printing";
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
      padding: "2rem"
    }}>
      <div style={{
        maxWidth: "600px",
        width: "100%",
        textAlign: "center",
        background: "#fff",
        borderRadius: "24px",
        padding: "3rem 2rem",
        boxShadow: "0 20px 60px rgba(0,0,0,0.1)"
      }}>
        {/* Logo */}
        <Link to="/" style={{ display: "inline-block", marginBottom: "2rem" }}>
          <img src={logo} alt="Melona" style={{ height: "60px" }} />
        </Link>

        {/* 404 Icon */}
        <div style={{
          width: "120px",
          height: "120px",
          margin: "0 auto 2rem",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #0F5D4F 0%, #22A06B 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontSize: "3rem",
          boxShadow: "0 15px 40px rgba(15, 93, 79, 0.3)"
        }}>
          <FiAlertCircle />
        </div>

        {/* Error Code */}
        <h1 style={{
          fontSize: "5rem",
          fontWeight: "800",
          background: "linear-gradient(135deg, #0F5D4F 0%, #22A06B 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          margin: "0 0 1rem 0",
          lineHeight: "1"
        }}>
          404
        </h1>

        {/* Title */}
        <h2 style={{
          fontSize: "1.75rem",
          fontWeight: "700",
          color: "#1A1A2E",
          marginBottom: "1rem"
        }}>
          Page Not Found
        </h2>

        {/* Description */}
        <p style={{
          fontSize: "1.125rem",
          color: "#6B7280",
          lineHeight: "1.7",
          marginBottom: "2.5rem"
        }}>
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to creating amazing prints and campaigns!
        </p>

        {/* Action Buttons */}
        <div style={{
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          flexWrap: "wrap"
        }}>
          <Link 
            to="/" 
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "1rem 2rem",
              background: "linear-gradient(135deg, #0F5D4F 0%, #22A06B 100%)",
              color: "#fff",
              borderRadius: "12px",
              fontWeight: "600",
              textDecoration: "none",
              transition: "all 0.3s ease",
              boxShadow: "0 8px 20px rgba(15, 93, 79, 0.3)"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = "0 12px 30px rgba(15, 93, 79, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 8px 20px rgba(15, 93, 79, 0.3)";
            }}
          >
            <FiHome /> Go to Homepage
          </Link>

          <button 
            onClick={() => window.history.back()}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              padding: "1rem 2rem",
              background: "#fff",
              color: "#0F5D4F",
              border: "2px solid #0F5D4F",
              borderRadius: "12px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#0F5D4F";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.color = "#0F5D4F";
            }}
          >
            <FiArrowLeft /> Go Back
          </button>
        </div>

        {/* Quick Links */}
        <div style={{
          marginTop: "3rem",
          paddingTop: "2rem",
          borderTop: "1px solid #E5E7EB"
        }}>
          <p style={{
            fontSize: "0.875rem",
            color: "#9CA3AF",
            marginBottom: "1rem",
            fontWeight: "600",
            textTransform: "uppercase",
            letterSpacing: "0.05em"
          }}>
            Quick Links
          </p>
          <div style={{
            display: "flex",
            gap: "1.5rem",
            justifyContent: "center",
            flexWrap: "wrap"
          }}>
            <Link to="/about" style={{ color: "#0F5D4F", textDecoration: "none", fontWeight: "500" }}>
              About
            </Link>
            <Link to="/services" style={{ color: "#0F5D4F", textDecoration: "none", fontWeight: "500" }}>
              Services
            </Link>
            <Link to="/contact" style={{ color: "#0F5D4F", textDecoration: "none", fontWeight: "500" }}>
              Contact
            </Link>
            <Link to="/login" style={{ color: "#0F5D4F", textDecoration: "none", fontWeight: "500" }}>
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
